import { NgStyle } from "@angular/common";
import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { AtgardService } from "../../services/atgard.service";
import { AvverkningsgruppForkortningPipe } from "./avverkningsgrupp-forkortning.pipe";

@Component({
    selector: "rask-atgard-badge",
    templateUrl: "./atgard-badge.component.html",
    styleUrls: ["./atgard-badge.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgStyle,
        AvverkningsgruppForkortningPipe
    ]
})
export class AtgardBadgeComponent {
    @Input() avverkningsgrupp: string;
    @Input() index: number;

    private readonly atgardService = inject(AtgardService);

    getColor(): string {
        return this.atgardService.getAvverkningsgruppColor(this.avverkningsgrupp);
    }
}
